import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ResponseNet } from 'src/app/model/ResponseNet.model';
import { ResponseUser, User } from 'src/app/model/User.model';
import { AjaxService } from 'src/app/service/ajax.service';
import { UtilService } from 'src/app/service/util.service';
import { UserService, UserToken } from 'src/app/services/user.service';
import { API } from 'src/environments/environment';

interface EmpresaOpcao {
  id: number;
  nome: string;
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  email: string;
  senha: string;
  jwt_decode: UserToken;
  user: ResponseUser = new ResponseUser();

  /** Empresa escolhida no login (enviada ao backend). */
  empresas: EmpresaOpcao[] = [];
  idEmpresaSelecionada: number | null = null;
  carregandoEmpresas = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private ajax: AjaxService,
    private util: UtilService,
    private userService: UserService,
  ) {
    this.user.user = new User();
    this.user.token = "";
  }

  ngOnInit() {
    this.email = '';
    this.senha = '';
    this.carregarEmpresas();
    this.route.queryParams.subscribe(params => {
      if (params['email']) {
        this.email = params['email'];
      }
      if (params['senha']) {
        this.senha = params['senha'];
      }
    });
  }

  login() {
    if (!this.idEmpresaSelecionada || this.idEmpresaSelecionada <= 0) {
      this.util.toasterShowError('Atenção', 'Selecione a empresa.');
      return;
    }

    this.util.showLoading();
    const loginEnc = encodeURIComponent(this.email || '');
    const senhaEnc = encodeURIComponent(this.senha || '');
    const url = `${API}Login/Logar?login=${loginEnc}&senha=${senhaEnc}&idEmpresa=${this.idEmpresaSelecionada}`;
    this.ajax.get(url)
      .subscribe((response: ResponseNet) => {
        this.util.closeLoading();

        if (response?.hasErrors || !response?.data) {
          this.util.toasterShowError('Atenção', response?.message || 'Nao foi possivel autenticar.');
          return;
        }

        this.jwt_decode = this.util.getDecodedAccessToken(response.data);
        if (!this.jwt_decode?.User) {
          this.util.toasterShowError('Atenção', 'Resposta de login invalida.');
          return;
        }
        this.jwt_decode.token = response.data;

        this.userService.saveUserData(this.jwt_decode);

        this.util.toasterShowSuccess("Sucesso", "Bem Vindo " + this.jwt_decode.User.Name);
        this.router.navigate(['/home']);

      }, err => {
        this.util.closeLoading();
        this.util.toasterShowError("Atenção", "Usuário ou senha inválidos");
      });
  }

  irParaCadastro() {
    this.router.navigate(['/cliente']);
  }

  private carregarEmpresas(): void {
    this.carregandoEmpresas = true;
    this.ajax.get(`${API}Login/EmpresasAtivas`).subscribe({
      next: (response: any) => {
        this.carregandoEmpresas = false;
        this.empresas = this.extrairListaEmpresas(response);
      },
      error: () => {
        this.carregandoEmpresas = false;
        this.empresas = [];
        this.util.toasterShowError('Atenção', 'Nao foi possivel carregar a lista de empresas.');
      }
    });
  }

  private extrairListaEmpresas(response: any): EmpresaOpcao[] {
    let atual = response;
    for (let i = 0; i < 3; i++) {
      if (Array.isArray(atual)) break;
      if (atual && typeof atual === 'object' && Object.prototype.hasOwnProperty.call(atual, 'data') && atual.data != null) {
        atual = atual.data;
      } else {
        break;
      }
    }
    if (!Array.isArray(atual)) return [];
    return atual
      .map((x: any) => {
        const o = this.util.converterParaLowercase(x || {});
        return {
          id: Number(o.id || 0),
          nome: String(o.nome || '')
        } as EmpresaOpcao;
      })
      .filter((e: EmpresaOpcao) => e.id > 0);
  }
}
